<div class="sidebar" [class.collapsed]="isCollapsed">
    <div class="sidebar-content">
        <div class="sidebar-header">
            <img
                class="sidebar-logo sidebar-logo--full"
                [src]="
                    themeService.isDark()
                        ? '../../../../assets/img/v2/logo-sem-fundo-dark.png'
                        : '../../../../assets/img/v2/logo-sem-fundo-ligth.png'
                "
                [routerLink]="'/v2/painel'"
            />
            <img
                class="sidebar-logo-collapsed"
                src="../../../../assets/img/icone_amarelo.png"
                [routerLink]="'/v2/painel'"
            />
            <button mat-icon-button type="button" (click)="onCloseSidebar()" class="sidebar-close-btn">
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <div class="sidebar-body">
            <app-v2-shell-sidebar-nav
                [isAdm]="isAdm"
                [habilitarGerenciadorAnuncios]="habilitarGerenciadorAnuncios"
                (toggleAi)="onToggleAi()"
            ></app-v2-shell-sidebar-nav>

            <div class="sidebar-footer-cards">
                <app-card-ai-menu [isCollapsed]="isCollapsed" (toggleAi)="onToggleAi()"></app-card-ai-menu>
                <app-card-suporte-menu [isCollapsed]="isCollapsed"></app-card-suporte-menu>
            </div>
        </div>
    </div>
</div>
